import { isCatalyticConverter } from '@rematter/modules/trade/utils/catalyticConverter';

import { createEntityTouchSelect } from './helpers/createEntityTouchSelect';

import { createQueryHook } from '~/shared/providers/api';

const useCatalyticMaterialsQuery = createQueryHook(
  'shared.selectCatalyticMaterial',
  (params: {
    ids?: string[];
    searchTerm?: string;
    limit?: number;
    offset?: number;
  }) => ({
    items: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
        },
        pagination: {
          limit: params.limit ?? 50,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
        skuNumber: true,
        itemGroup: {
          name: true,
        },
        category: {
          id: true,
          name: true,
          attributes: true,
        },
        attributeValues: true,
      },
    },
  }),
  {
    select: (data) =>
      (data?.items.entries ?? []).filter((entry) =>
        isCatalyticConverter(entry.category?.name),
      ),
  },
);

type EntityProps = {
  name: string;
  skuNumber: string;
};

const formatOptionLabelText = (entity: EntityProps) => {
  const sku = entity.skuNumber?.replace(/_/g, ' ') ?? '';
  const relevantSkuNumber = sku.length > 20 ? undefined : sku;
  const numericPart = relevantSkuNumber?.match(/\d+/)?.[0];

  return `${numericPart ? `#${numericPart} - ` : ''}${entity.name}`;
};

export const SelectCatalyticMaterialTouch =
  createEntityTouchSelect.remotelySearched(
    'SelectCatalyticMaterial',
    useCatalyticMaterialsQuery,
    {
      formatLabel: (entity) => formatOptionLabelText(entity),
      formatSubLabel: (entity) => entity.itemGroup?.name ?? '',
    },
  );
